import React from 'react';
import Text from '@amzn/meridian/text';

interface KeyTermType {
  term: string;
  description: string;
}

interface KeyTermContentProps {
  content: Array<KeyTermType> ;
}

const KeyTermContent: React.FC<KeyTermContentProps> = ({content}) => (
  <Text tag='ul'>
    {content.map((keyTerm) => <li>{keyTerm.term} - {keyTerm.description}</li>)}
  </Text>
);

export default KeyTermContent;